import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import Schools from "@/pages/Schools";
import Article from "@/pages/Article";
import { WhatsAppButton } from "@/components/WhatsAppButton";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/schools" element={<Schools />} />
        <Route path="/journal/:slug" element={<Article />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <WhatsAppButton />
      <Toaster position="top-center" richColors closeButton />
    </BrowserRouter>
  );
}

export default App;
